import { Location } from "react-router-dom";
import { menuItemsDTO } from "./SidebarContentV2";
import SidebarMenuItem from "./SidebarMenuItem";

const SideBarSubMenu = ( {submenus, depthLevel, currentLocation}: SideBarSubMenuProps ) => {
  depthLevel = depthLevel + 1;
  return (
    <>
      {submenus.map((submenu: any, index: number) => (
        <SidebarMenuItem items={submenu} key={index} depthLevel={depthLevel} currentLocation={currentLocation} />
      ))}
    </>
  );
};

export default SideBarSubMenu;

interface SideBarSubMenuProps {
  submenus: menuItemsDTO[];
  depthLevel: number;
  currentLocation: Location
}